export type ForbiddenViewTranslation = {
  subtitle: string;
  title: string;
};

export const forbiddenViewTranslation: ForbiddenViewTranslation = {
  subtitle: 'Jeżeli uważasz, że to błąd, skontaktuj się ze swoim przełożonym',
  title: 'Nie masz dostępu do tego zasobu',
};
